import { QrCodeObject } from "@/models/QrCodeObject";

export interface QrcodeState {
    qrcodeObject: QrCodeObject;
    logoB64: string;
    videoUrl: string;
    customHtml: string;
    customJs: string[];
    error: { title: string; text: string };
}

const defaultState: QrcodeState = {
    qrcodeObject: null,
    logoB64: "",
    videoUrl: "",
    customHtml: "",
    customJs: [],
    error: { title: "", text: "" }
};

export default defaultState;
